<!-- PANE 3 -->
<div class="pane3" #paneContent>
  <!-- Pane 3 header toolbar -->
  <mat-toolbar class="pane-header">
    <!-- Mobile menu toggle button - only visible on mobile -->
    <button *ngIf="isMobileView"
            mat-icon-button
            class="mobile-menu-toggle"
            (click)="onToggleMobileNav()"
            matTooltip="Show Navigation">
      <mat-icon>view_quilt</mat-icon>
    </button>

    <!-- Navigation path display -->
    <div class="navigation-path-container">
      <div class="navigation-path" *ngIf="navigationPathItems && navigationPathItems.length > 0">
        <span *ngFor="let item of navigationPathItems; let i = index" class="path-item">
          <span class="path-name" [class.last-item]="i === navigationPathItems.length - 1">
            {{ formatNodeName(item.name, item.hindiName) }}
          </span>
          <mat-icon *ngIf="i < navigationPathItems.length - 1" class="path-separator">chevron_right</mat-icon>
        </span>
      </div>
      <span *ngIf="!navigationPathItems || navigationPathItems.length === 0" class="toolbar-title">All Posts</span>
    </div>

    <span class="spacer"></span>
  </mat-toolbar>

  <!-- Sub-header -->
  <div class="sub-header with-button">

    <!-- Actions container for checkbox and button -->
    <div class="sub-header-actions">
      <!-- Left section with Height and Preview selectors -->
      <div class="left-actions">
        <!-- Height Selector Dropdown -->
        <mat-select class="height-selector-dropdown"
                    [(value)]="selectedHeight"
                    (selectionChange)="onHeightChange()"
                    placeholder="Height Selector">
          <mat-option value="small">Small Height</mat-option>
          <mat-option value="medium">Medium Height</mat-option>
          <mat-option value="large">Large Height</mat-option>
        </mat-select>

        <!-- Preview Selector Dropdown -->
        <mat-select class="preview-selector-dropdown"
                    [(value)]="selectedPreview"
                    (selectionChange)="onPreviewChange()"
                    placeholder="Preview Selector">
          <mat-option value="none">Show File Details</mat-option>
          <mat-option value="thumbnail" [disabled]="!isThumbnailEnabled()">Show Thumbnail</mat-option>
          <mat-option value="preview" [disabled]="!isPreviewEnabled()">Show Preview - Single</mat-option>
          <mat-option value="preview-all" [disabled]="!isPreviewEnabled()">Show Preview - All</mat-option>
        </mat-select>
      </div>

      <!-- Center section with Create Topic button -->
      <div class="center-actions">
        <!-- Create a New Topic button -->
        <button mat-raised-button color="primary" class="create-topic-button" (click)="openUploadBundleDialog()" *ngIf="isInternalUser">
          <mat-icon>add</mat-icon>
          <span class="button-text">Create a New Topic</span>
        </button>
      </div>

      <!-- Right section with Show Details checkbox -->
      <div class="right-actions">
        <!-- Hide/Show Details checkbox - only show when details are hidden -->
        <mat-checkbox class="hide-details-checkbox"
                      *ngIf="!showDetails"
                      [(ngModel)]="showDetails"
                      (change)="onShowDetailsChange()">
          Show Details
        </mat-checkbox>
      </div>
    </div>
  </div>

  <!-- Main content area -->
  <div class="pane-content">

      <!-- File Processing Component -->
      <app-file-processing
        [selectedSubject]="selectedSubject"
        [selectedSection]="selectedSubItem"
        [adminMode]="isAdminMode"
        [selectedHeight]="selectedHeight"
        [selectedPreview]="selectedPreview"
        (viewFileInDetails)="handleViewFile($event)">
      </app-file-processing>

      <!-- Download Button for non-internal users -->

      <!-- Login message area (shown when download is clicked by not-logged-in user) -->
      <div *ngIf="showLoginPrompt" class="login-prompt">
        <h3>Login Required</h3>
        <p>Please log in with your Gmail ID to download the content.</p>
        <app-login-gmail (userLoggedIn)="onUserLoggedIn($event)"></app-login-gmail>
      </div>

  </div>
</div>
